import { useState } from "react";
import { useOnboardingStep } from "../hooks/useOnboardingStep";
import { useRedirectWhenNoInvitation } from "../hooks/useRedirectWhenNoInvitation";
import { OnboardingIntro } from "../components/OnboardingIntro/OnboardingIntro";
import { OnboardingQuizContainer } from "../components/OnboardingQuizContainer/OnboardingQuizContainer";

export function OnboardingEnrollPage() {
  const [isQuizStarted, setIsQuizStarted] = useState(false);

  const { completeStep } = useOnboardingStep();

  useRedirectWhenNoInvitation();

  const handleStartQuiz = () => {
    setIsQuizStarted(true);
    completeStep("intro");
  };

  return isQuizStarted ? (
    <OnboardingQuizContainer stepName="fit" />
  ) : (
    <OnboardingIntro onStart={handleStartQuiz} />
  );
}

export default OnboardingEnrollPage;
